export { default } from "./ListDepartments";
